"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerError = exports.RequestError = void 0;
exports.makeLoggableError = makeLoggableError;
const lodash_1 = __importDefault(require("lodash"));
/**
 * For more type safety, use the @aops-trove/fast-error package instead.
 *
 * Extends generic Error class. Basic error constructor for endpoints to throw
 * 400-level error messages back to the user.
 *
 * @example
 * import {RequestError} from "@aops-trove/fast-server-common"
 * throw new RequestError("E_SAMPLE_ERROR", exception.message);
 */
class RequestError extends Error {
    code;
    status;
    moreInfo;
    constructor(code, info) {
        const infoResolved = (lodash_1.default.isString(info) ? { message: info || undefined } : info) || {};
        const { message = "Request error", status = 400, moreInfo = {}, } = infoResolved;
        super(message);
        this.name = "RequestError";
        this.code = code;
        this.status = status;
        this.moreInfo = moreInfo;
        Error.captureStackTrace(this, this.constructor);
    }
}
exports.RequestError = RequestError;
/**
 * For more type safety, use the @aops-trove/fast-error package instead.
 *
 * Extends generic Error class. Basic error constructor for endpoints to throw
 * 500-level error messages back to the user.
 *
 * @example
 * import {ServerError} from "@aops-trove/fast-server-common"
 * throw new ServerError("E_SAMPLE_ERROR", exception.message);
 */
class ServerError extends Error {
    code;
    status;
    moreInfo;
    constructor(code, info) {
        const infoResolved = (lodash_1.default.isString(info) ? { message: info || undefined } : info) || {};
        const { message = "Server error", status = 500, moreInfo = {}, } = infoResolved;
        super(message);
        this.name = "ServerError";
        this.code = code;
        this.status = status;
        this.moreInfo = moreInfo;
        Error.captureStackTrace(this, this.constructor);
    }
}
exports.ServerError = ServerError;
/**
 * Given a thrown exception, turn it into an object fit to send to LogApi.
 */
function makeLoggableError(e) {
    return lodash_1.default.pickBy({
        message: e.message,
        name: e.name,
        type: e.type,
        code: e.code,
        cause: e.cause,
        status: e.status,
        stack: e.stack,
        moreInfo: e.moreInfo,
    }, (a) => a !== undefined);
}
//# sourceMappingURL=Errors.js.map